import { VesselMessage } from '../../../../types/VesselMessage';
import { Link } from '../../../cdl/Link/Link';
import { BooleanStatus } from '../../../common/BooleanStatus/BooleanStatus';
import { VerticalDetail } from '../../../common/Detail/VerticalDetail';
import { formatAddress } from '../../../common/helpers/formatAddress.helper';
import { formatCompanyName } from '../../../common/helpers/formatCompanyName.helper';
import { formatDate } from '../../../common/helpers/formatDate.helper';
import { formatVessel } from '../../../common/helpers/formatVessel.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';
import { VesselActiveFlag } from '../../VesselOverview/ActiveFlag/VesselActiveFlag';

interface VesselDetailDataSheetProps {
    vessel: VesselMessage;
}

export const VesselDetails = ({ vessel }: VesselDetailDataSheetProps) => {
    const role = useRole();

    return (
        <Box display="grid" gap={16}>
            {!role.isOneCompanyUser() ? (
                <VerticalDetail
                    label={translate('vessel.company')}
                    value={formatCompanyName({
                        company: vessel.customer,
                    })}
                />
            ) : null}

            <VerticalDetail label={translate('order.vessel')} value={formatVessel({ vessel })} />
            <VerticalDetail label={translate('vessel.lastedit')} value={formatDate({ date: vessel.dateUpdated })} />
            <VerticalDetail label={translate('vessel.invoiceVAT')} value={vessel.invoiceVAT} />
            <VerticalDetail label={translate('vessel.invoiceEmailAddress')} value={vessel.invoiceEmailAddress} />
            <VerticalDetail
                label={translate('vessel.defaultsupplier')}
                value={
                    vessel.defaultSupplier
                        ? formatCompanyName({
                              company: vessel.defaultSupplier,
                          })
                        : undefined
                }
            />
            <VerticalDetail
                label={translate('vessel.defaultContract')}
                value={
                    vessel.defaultContract ? (
                        <Link
                            to="/contracts/$id"
                            params={{ id: vessel.defaultContract.id }}
                            state={{ vesselId: vessel.id }}
                            size="small"
                        >
                            {vessel.defaultContract.name}
                        </Link>
                    ) : undefined
                }
            />
            <VerticalDetail
                label={translate('global.status')}
                value={<VesselActiveFlag active={vessel.active} dateActiveUpdated={vessel.dateActiveUpdated} />}
            />
            <VerticalDetail label={translate('global.contact.email')} value={vessel.email} />
            <VerticalDetail
                label={translate('global.address.invoiceaddress')}
                value={formatAddress({ address: vessel.invoiceAddress })}
            />
            <VerticalDetail
                label={translate('vessel.postalAddress')}
                value={formatAddress({ address: vessel.postalAddress })}
            />
            <VerticalDetail
                label={translate('vessel.lubricationChart')}
                value={
                    vessel.lubricationChart ? (
                        <Link href={vessel.lubricationChart.downloadUrl} target="_blank" size="small">
                            {vessel.lubricationChart.name}
                        </Link>
                    ) : undefined
                }
            />
            {role.isSuperAdmin() ? (
                <>
                    <VerticalDetail
                        label={translate('vessel.paying')}
                        value={<BooleanStatus value={vessel.paying} />}
                    />
                    <VerticalDetail
                        label={translate('vessel.directOrderAllowed')}
                        value={<BooleanStatus value={vessel.directOrderAllowed} />}
                    />
                </>
            ) : null}
        </Box>
    );
};
